import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  paper: {
    paddingTop: '3rem',
    paddingBottom: '3rem',
  },
  title: {
    marginBottom: '2rem',
    letterSpacing: 'normal',
  },
  description: {
    margin: 0,
  },
  button: {
    marginTop: '2rem',
  },
}));
